import { Injectable } from '@angular/core';
import { ConnectionBackend, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers } from '@angular/http';
import { appConfig } from '../app.config';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class CustomHttp extends Http {
  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
    super(backend, defaultOptions);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.addJwt(options);
    if (url.substring(0, 5) === 'asset') {
      return super.get( url, options).catch(this.handleError);
    }
    return super.get(appConfig.apiUrl + url, options).catch(this.handleError);
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.addJwt(options);
    return super.post(appConfig.apiUrl + url, body, options).catch(this.handleError);
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.addJwt(options);
    return super.put(appConfig.apiUrl + url, body, options).catch(this.handleError);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.addJwt(options);
    return super.delete(appConfig.apiUrl + url, options).catch(this.handleError);
  }

  private addJwt(options?: RequestOptionsArgs): RequestOptionsArgs {
    options = options || new RequestOptions();
    options.headers = options.headers || new Headers();

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.api_token) {
      options.headers.append('token',  currentUser.api_token);
      options.headers.append('lang',  currentUser.lang);
      options.headers.append('year',  currentUser.year);
      options.headers.append('branch',  currentUser.branch_id);
      options.headers.append('department',  currentUser.department_id);
    }
    return options;
  }

  private handleError(error: any) {
    if (error.status === 401) {
      window.location.href = '/#/pages/login';
    }

    return Observable.throw(error._body);
  }
}

export function customHttpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions): Http {
  return new CustomHttp(xhrBackend, requestOptions);
}

export let customHttpProvider = {
  provide: Http,
  useFactory: customHttpFactory,
  deps: [XHRBackend, RequestOptions]
};





// WEBPACK FOOTER //
// ./src/app/helpers/custom-http.ts